import styled from 'styled-components';

import { fadeInAnimation } from '../styles';
import { FullScreenBackground } from './styled';

export const BackContainer = styled.div`
  position: fixed;
  inset: 0;
  overflow: hidden;
  height: 100%;
  z-index: -1;
`;

export const BackImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  &[data-apply-gradient='true'] {
    mask-image: linear-gradient(to top, transparent, var(--pageBackground));
  }

  animation: ${fadeInAnimation} 0.3s ease-in;
`;

export const StyledOverlay = styled(FullScreenBackground)`
  background-color: var(--pageBackground);
  overflow-x: hidden;
`;

export const ModalBody = styled.dialog`
  /* reset dialog's default styles */
  all: unset;
  display: flex;
  justify-content: center;
  min-width: 100vw;
  height: 100svh;
  color: var(--pageParagraphForeground);
  text-align: center;
  position: relative;
  align-items: flex-start;
`;
